import { getHiDpiRatio } from '../../../render-settings';

const STATES = {
  PENDNIG: 'PENDING',
  LOADING: 'LOADING',
  LOADED: 'LOADED'
};

export function makeTile (url) {
  const img = new Image();
  let state = STATES.PENDNIG;
  let controller;

  function remove () {
    controller && controller.abort();
    controller = null;
    img.remove();
    state = STATES.PENDNIG;
  }

  async function load () {
    if (state === STATES.PENDNIG) {
      if (window.AbortController) { // protect IE
        controller = new window.AbortController();
      }
      state = STATES.LOADING;
      try {
        let res = await fetch(url, controller);
        res = await res.blob();
        img.onload = () => URL.revokeObjectURL(img.src);
        img.onerror = () => URL.revokeObjectURL(img.src);
        img.src = await getCompensatedDataUrl(res);
        state = STATES.LOADED;
      } catch (ex) {
        state = STATES.PENDNIG;
        if (ex.name !== 'AbortError') {
          throw ex;
        }
      }
    }
  }

  return {img, load, remove};
}

// This element is used to scale images from imageserver. To paint it needs to be attached to the DOM, but we don't want
// it to clutter the UI so we size it 0
let canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.style.maxWidth = canvas.style.maxHeight = canvas.style.padding = canvas.style.margin = canvas.style.border = 0;
document.addEventListener('DOMContentLoaded', () => {
  document.body.appendChild(canvas);
});

// Takes into account the user's scale factor and scales the image retrieved from imageserver as necessary
// to maintain image quality.
function getCompensatedDataUrl (blob) {
  return new Promise((resolve, reject) => {
    const scale = getHiDpiRatio(); // returns 1 if no scaling or if hidpi compensation is disabled
    // There's a performance hit associated with this technique, so don't use it unless we have to
    // to maintain image quality.
    if (scale === 1) {
      const objectURL = URL.createObjectURL(blob);
      resolve(objectURL);
    } else {
      createImage(blob).then((sourceImage) => {
        canvas.height = sourceImage.height * scale;
        canvas.width = sourceImage.width * scale;
        ctx.imageSmoothingEnabled = false;
        ctx.scale(scale, scale);
        ctx.drawImage(sourceImage, 0, 0);
        resolve(canvas.toDataURL());
      });
    }
  });
}

function createImage (blob) {
  if (window.createImageBitmap) {
    return window.createImageBitmap(blob);
  }
  return createHtmlImage(blob);
}

function createHtmlImage (blob) {
  return new Promise((resolve, reject) => {
    const objUrl = URL.createObjectURL(blob);
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.onload = () => {
      image.onload = null;
      URL.revokeObjectURL(objUrl);
      resolve(image);
    };
    image.onerror = () => {
      image.onerror = null;
      URL.revokeObjectURL(objUrl);
      reject(image);
    };
    image.src = objUrl;
  });
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/rendering/tile.js